import Icon from '@ant-design/icons';

import KeySvg from '@/components/Icon/svgs/key.svg';
import { useTranslation } from '@/i18n/client';
import { EVENT } from '@/utils/event';

import styles from '../../index.less';

function TryNewFeatureItem(): JSX.Element {
  const { t } = useTranslation();

  return (
    <div
      className={styles.menuItem}
      onClick={() => {
        dispatchEvent(new Event(EVENT.UNFOLD_API_KEY));
      }}
    >
      <Icon className={styles.icon} component={KeySvg} />
      <span className={styles.text}>{t('menu.tryNewFeature')}</span>
      <div
        className={
          'h-[16px] px-1 bg-[#7B67EF] rounded-[24px] flex items-center justify-center ml-auto'
        }
      >
        <span className="text-[10px] text-[#fefdff]  whitespace-nowrap">{t('leftTabs.beta')}</span>
      </div>
    </div>
  );
}

export default TryNewFeatureItem;
